import { API_ENDPOINTS } from "@/api/services/attendanceManagement/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const adminAttendanceReportListApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminAttendanceReport: builder.query({
      query: ({ month, sortDirection, page, size, search }) => ({
        url: API_ENDPOINTS.ADMIN_ATTENDANCE_REPORT.GET_ADMIN_ATTENDANCE_REPORT(
          month,
          sortDirection,
          page,
          size,
          search
        ),
      }),
      providesTags: ["AdminAttendanceReport"],
    }),

    getAdminAttendanceTracker: builder.query({
      query: ({
        startDate,
        endDate,
        empId,
        workLocation,
        deparment,
        swipeMethod,
      }) => ({
        url: API_ENDPOINTS.ADMIN_ATTENDANCE_REPORT.GET_ADMIN_ATTENDANCE_TRACKER(
          startDate,
          endDate,
          empId,
          workLocation,
          deparment,
          swipeMethod
        ),
      }),
      providesTags: ["AdminAttendanceTracker"],
    }),

    // download report excel
    getDownloadReportExcel: builder.query({
      query: ({ yearMonth }) => ({
        url: API_ENDPOINTS.ADMIN_ATTENDANCE_REPORT.GET_DOWNLOAD_REPORT_EXCEL(
          yearMonth
        ),
        responseHandler: async (response) => response.blob(), // Ensure Blob conversion
      }),
      providesTags: ["AdminAttendanceReport"],
    }),
    getDownloadTrackerReportExcel: builder.query({
      query: ({
        startDate,
        endDate,
        empId,
        workLocation,
        deparment,
        swipeMethod,
      }) => ({
        url: API_ENDPOINTS.ADMIN_ATTENDANCE_REPORT.GET_DOWNLOAD_TRACKER_EXCEL(
          startDate,
          endDate,
          empId,
          workLocation,
          deparment,
          swipeMethod
        ),
        responseHandler: async (response) => response.blob(), // Ensure Blob conversion
      }),
      providesTags: ["AdminAttendanceTracker"],
    }),
  }),
});

export const {
  useGetAdminAttendanceReportQuery,
  useGetAdminAttendanceTrackerQuery,
  useLazyGetDownloadReportExcelQuery,
  useLazyGetDownloadTrackerReportExcelQuery,
} = adminAttendanceReportListApi;
